import templateService from '../request/service/template-service';
import store from '../store'
export default {
    validatePublicTemplate(next, to){
        let templateId = to.params.id;
        if(templateId){
            templateService.checkPermissionByTemplateId(templateId).then((data) => {
                store.commit('app/set_public_templateId', data ? templateId : null);
                next();
            }).catch(() => {
                next({path: '/noProjectAuthority', replace: true})
            });
        }else{
            next();
        }
    }
}